import gtmPush from './gtmPush';

interface Params {
    [key: string]: string | number | Record<string, unknown>;
}

type GtmWithCallback = Params | { eventCallback?: (value: unknown) => void };

export default (event: string, params?: GtmWithCallback) => gtmPush({ event, ...params });
